var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand"},[_c('Carousel',{ref:"carousel",attrs:{"perPageCustom":[
            [650, 3],
            [800, 4],
            [1024, 5],
            [1250, 6],
            [1500, 7] ],"navigationEnabled":true}},[(_vm.brandsList[0] && _vm.brandsList[0].values)?_vm._l((_vm.brandsList[0].values),function(item,index){return _c('Slide',{key:index},[_c('div',{staticClass:"brand-item--wrap",on:{"click":function($event){$event.stopPropagation();return _vm.filter(item)}}},[_c('router-link',{staticClass:"brand-item",class:{'active': _vm.selectedFilters.find(function (ref) {
                var itemSlug = ref.itemSlug;

                return itemSlug === item.slug;
        })},attrs:{"to":_vm.generateFilterLink(item)}},[(item.image)?_c('img',{attrs:{"src":item.image,"alt":item.title}}):_vm._e(),_vm._v(" "+_vm._s(item.title)+" ")])],1)])}):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }